module.exports = __webpack_public_path__ + "static/media/GettyImages-1229380660_crop.a9bfc530.png";